exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.extra-guests {\n\tdisplay: table;\n\twidth: 100%;\n}\n.extra-guests tr:first-child {\n\theight: 32px;\n}\n.extra-guests td, .extra-guests th {\n\twidth: 20%;\n\ttext-align: center;\n}\n.extra-guests td:first-child {\n\tfont-weight: bold;\n}\n\n", ""]);

// exports
